export default __webpack_public_path__ + "static/media/round-user.460ce49a.png";